module.exports = __webpack_public_path__ + "img/UMI.960c0331.svg";